<body>
<div class="container" data-aos="fade-down" data-aos-duration="1000">
<div class="row">
  <div class="profileSideBar col-md-3  mb-3">
      <div class="bg-white">
        <div class="d-flex flex-row align-items-center  bg-info pt-3 pb-3 text-white">
          <i class="fa fa-long-arrow-left mr-2 mb-2 ml-2"></i>
          <a routerLink="" class="text-white"><h6>Back to home</h6></a>
        </div>
          <div class="heading round mb-1 text-dark">
            <i
            class="fa fa-user-circle-o fa-5x rounded-circle mb-3 bg-white"
            aria-hidden="true"
          ></i>
              <h1 class="text-capitalize">{{this.name}}</h1>
              <p> {{this.email}}</p>
          </div>
          <ul class="nav">
              <li class="active col-md-12 p-3 "><i class="fa fa-user"></i> Profile</li>
              <li class="col-md-12 p-3 "><a routerLink="/profile"> <i class="fa fa-edit"></i> Edit profile</a></li>
              <li class="col-md-12 p-3 "><a routerLink="/order/history"> <i class="fa fa-edit"></i>Order History</a></li>
          </ul>
      </div>
  </div>
  <div class="profile col-md-9">
          <div class="dataProfile bg-white p-5 mb-3">
              <h1>Profile</h1>
              <div class="row">
                  <div class="dataList">
                      <p><span>Name </span>: {{this.name}}</p>
                  </div>
                  <div class="dataList">
                      <p><span>Email </span>:  {{this.email}}</p>
                  </div>
                  <div class="dataList">
                      <p><span>First Name </span>: {{this.firstname}}</p>
                  </div>
                  <div class="dataList">
                      <p><span>Last Name </span>: {{this.lastname}}</p>
                  </div>
                  <div class="dataList">
                      <p><span>Birthday</span>:  {{this.age}}</p>
                  </div>
                  <div class="dataList">
                      <p><span>Address </span>: {{this.address}}</p>
                  </div>
              </div>
          </div>
          <div class="dataProfile bg-white p-5 mb-3">
              <h1>Adress</h1>
              <div class="row">
                  <div class="dataList">
                      <p><span>Country </span>: {{this.country}}</p>
                  </div>
                  <div class="dataList">
                      <p><span>Province </span>: {{this.province}}</p>
                  </div>
                  <div class="dataList">
                      <p><span>City </span>: {{this.city}}</p>
                  </div>
                  <div class="dataList">
                      <p><span>District </span>: {{this.district}}</p>
                  </div>
                  <div class="dataList">
                      <p><span>Village </span>: {{this.village}}</p>
                  </div>
                  <div class="dataList">
                      <p><span>Phone </span>: {{this.phone}}</p>
                  </div>
                  <div class="dataList">
                      <p><span>Zip </span>: {{this.zip}}</p>
                  </div>
                  <div class="dataList">
                      <p><span>Address </span>: {{this.address}}</p>
                  </div>
              </div>
          </div>
  </div>
</div>
</div>
</body>
